import React from 'react';

interface IConditionControlProps {
    children: () => any;
    condition: boolean;
}

export const ConditionControl: React.FC<IConditionControlProps> = React.memo((props) => props.condition && props.children());
